import ApiService from '@/services/Base/ApiService';

/* eslint-disable */
const getDefaultState = () => {
  return {
    periods: [],

    selectedTwoWayPeriod: null,
    selectedThreeWayPeriod: null,
  }
}

const state = getDefaultState()

const getters = {
  getPeriods(state) {
    return state.periods;
  },
}

const mutations = {
  setPeriods(state, data) {
    state.selectedTwoWayPeriod = data.result[0];
    state.selectedThreeWayPeriod = data.result[0];
    state.periods = data.result;
  },

  setSelectedTwoPeriod(state, period) {
    state.selectedTwoWayPeriod = period;
  },
  setSelectedThreePeriod(state, period) {
    state.selectedThreeWayPeriod = period;
  },
}

const actions = {
  async fetchPeriods(context) {
    try {
      if (context.state.periods.length > 0) {
        return;
      }
      const response = await ApiService.get('MixedModePeriod');
      if (response.statusCode === 200) {
        context.commit('setPeriods', response)
      } else {
        console.error('Error fetching data:', response.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
